import {applyMiddleware, combineReducers, createStore} from "redux";
import thunkMiddleware from "redux-thunk";

import {persistReducer, persistStore} from 'redux-persist'
import storage from 'redux-persist/lib/storage';

import {loginReducer} from "./reducers/login-reducer";
import {composeWithDevTools} from 'redux-devtools-extension';
import {masterOfActs} from "./reducers/master-of-acts-reducer";
import {handbookReducer} from "./reducers/handbook-reducer";
import {projectReducer} from "./reducers/project-reducer";
import {actReducer} from "./reducers/act-reducer";
import {actTemplateReducer} from "./reducers/act-template-reducer";
import {notificationReducer} from "./reducers/notification-reducer";
import {contractReducer} from "./reducers/contract-reducer";
import {userProfile} from "./reducers/user-profile-reducer";
import {actStatisticReducer} from "./reducers/act-statistic-reducer.js";
import {usersReducer} from "./reducers/users-reducer";
import {companiesReducer} from "./reducers/companies-reducer";
import {normativeDocumentsReducer} from "./reducers/normative-documents-reducer.js";
import {mobileDevicesReducer} from "./reducers/mobile-devices-reducer.js";
import {projectsEditReducer} from "./reducers/projects-edit-reducer.js";
import {handbookEditReducer} from "./reducers/handbook-edit-reducer.js";
import {wordTemplateEditReducer} from "./reducers/word-template-edit-reducer.js";
import {libraryReducer} from "./reducers/library-reducer.js";
import {companyChartReducer} from "./reducers/chart-reducer";
import {contractorActReducer} from "./reducers/contractor-act-reducer";
import {contractorViolationReducer} from "./reducers/contractor-violation-reducer";
import {crewDeepAnaliticsReducer} from "./reducers/chart-deep-analitics"
import { excelTemplateEditReducer } from "./reducers/excel-template-edit-reducer.js";

const persistConfig = {
    key: 'appState',
    storage: storage,
    whitelist: ['userProfile', 'projectReducer', 'contractReducer']  
}

const allReducers = combineReducers({
        loginReducer,
        userProfile,
        masterOfActs,
        handbookReducer,
        projectReducer,
        contractReducer,
        actReducer,
        actTemplateReducer,
        notificationReducer,
        actStatisticReducer,
        usersReducer,
        companiesReducer,
        normativeDocumentsReducer,
        mobileDevicesReducer,
        projectsEditReducer,
        handbookEditReducer,
        wordTemplateEditReducer,
        excelTemplateEditReducer,
        libraryReducer,
        companyChartReducer,
        contractorActReducer,
        contractorViolationReducer,
        crewDeepAnaliticsReducer,
    },
)

const RESET_APP = 'RESET_APP'

const rootReducer = (state, action) => {
    if (action.type === RESET_APP) {
        state = undefined;
    }

    return allReducers(state, action);
}


export const store = createStore(
    persistReducer(
        persistConfig,
        rootReducer
    ), composeWithDevTools(
        applyMiddleware(thunkMiddleware)
    )
)

export const resetStore = () => store.dispatch({type: RESET_APP})

export const persistor = persistStore(store)